module.exports = __webpack_public_path__ + "img/Group 3013.b1cfa769.svg";